import { render, staticRenderFns } from "./CreateSachDialog.vue?vue&type=template&id=4311c1c6&scoped=true"
import script from "./CreateSachDialog.vue?vue&type=script&lang=js"
export * from "./CreateSachDialog.vue?vue&type=script&lang=js"
import style0 from "./CreateSachDialog.vue?vue&type=style&index=0&id=4311c1c6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../home/zarzar/Documents/public-solution/bis-office/web/auftragsbuch/node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4311c1c6",
  null
  
)

export default component.exports